/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextIndentDecreaseIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Indent Decrease',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="24" x="8" y="28" />
    <rect height="4" rx="1" ry="1" width="12" x="20" y="20" />
    <rect height="4" rx="1" ry="1" width="12" x="20" y="12" />
    <rect height="4" rx="1" ry="1" width="24" x="8" y="4" />
    <path
      d="M8 14v-3.328a.5.5 0 0 0-.866-.341L0 18l7.134 7.669A.5.5 0 0 0 8 25.328V22h7a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
